'use client'

import { Footer, Header } from '@/components/home'
import { useAuth } from '@/contexts/AuthContext'

export default function MarketingLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const { currentUser, isLoading } = useAuth()

  // If user is authenticated, don't render header/footer to prevent flicker
  if (currentUser) {
    return <div className='min-h-screen'>{children}</div>
  }

  // If still loading, show minimal layout to prevent flicker
  if (isLoading) {
    return <div className='min-h-screen'>{children}</div>
  }

  return (
    <div className='min-h-screen'>
      <Header />
      <main className='lp-container'>{children}</main>
      <Footer />
    </div>
  )
}
